import { z } from 'zod'

export const mundoDeviceSchema = z.object({
  statusName: z.enum(['DESBLOQUEADO', 'EN ORDEN']),
  statusId: z.number()
})
